var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaloriesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.41 10.7199H15.32V3.5199C15.32 1.8399 14.41 1.4999 13.3 2.7599L12.5 3.6699L5.73001 11.3699C4.80001 12.4199 5.19001 13.2799 6.59001 13.2799H9.68001V20.4799C9.68001 22.1599 10.59 22.4999 11.7 21.2399L12.5 20.3299L19.27 12.6299C20.2 11.5799 19.81 10.7199 18.41 10.7199Z",
    fill: "#FF627D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaloriesIcon);
export default __webpack_public_path__ + "static/media/calories-icon.f0a4f0850ba1e6ade27d7884a1487eb7.svg";
export { ForwardRef as ReactComponent };